<template>
  <button
    depressed
    style="border-radius: 0; width: 100%; height: 100%; color: white; border-right: 1px solid #eee"
    :style="{
      'background-color':
        $store.state.livechat.app == social.fullValueForUse
          ? $vuetify.theme.primary
          : colors.grey.base
    }"
    class="ma-0"
    dark
    @click="$emit('changeApp')"
  >
    <slot />
  </button>
</template>

<script>
import colors from 'vuetify/es5/util/colors'
export default {
  props: ['social'],
  computed: {
    colors() {
      return colors
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/livechat/LivechatTabButton.vue